import {
    Swiper,
    Navigation,
    Autoplay,
    Keyboard,
} from 'swiper';

Swiper.use([Autoplay, Navigation, Keyboard]);

const navigation = (target) => {
    const swiperClass = {
        nextEl: '.' + target + '-swiper-controls__next',
        prevEl: '.' + target + '-swiper-controls__prev',
    }

    return swiperClass;
}

$(window).on('load', function() {
    swipers();
});

const swipers = () => {
    homeSwiper();
    aboutUs();
    situatie();
    singleAanbod();
    fullAanbod('image-full');
    fullAanbod('floorplan');
    processlider();
    relatedSwiper();
    contentslider();
    reviewsSwiper();
    teamSwiper();
    vacaturesSwiper();
    dienstenSwiper();
}

const homeSwiper = () => {
    return new Swiper('.home-swiper', {
        spaceBetween: 0,
        loop: true,
        autoplay: {
            delay: 5000,
        },
    });
}

const aboutUs = () => {
    return new Swiper('.about-us__swiper', {
        spaceBetween: 0,
        loop: true,
        autoplay: {
            delay: 8000,
        },
    });
}

const situatieGallerij = () => {
    return new Swiper('.situatie-gallery-swiper', {
        spaceBetween: 0,
        navigation: navigation('situatie-gallery'),
        breakpoints: {
            993: {
                slidesPerView: 2,
            },
            0: {
                slidesPerView: 1,
            },
        },
    });
};

const situatie = () => {
    situatieGallerij();

    return new Swiper('.situatie-swiper', {
        spaceBetween: 30,
        navigation: navigation('situatie'),
        breakpoints: {
            993: {
                slidesPerView: 2,
            },
            0: {
                slidesPerView: 1.05,
                spaceBetween: 15,
            },
        },
    });
}

const singleAanbod = () => {
    return new Swiper('.single-swiper', {
        spaceBetween: 0,
        loop: true,
        navigation: navigation('single'),
        breakpoints: {
            993: {
                slidesPerView: 2,
            },
            0: {
                slidesPerView: 1.2,
            },
        },
        keyboard: true,
    });
}

const processlider = () => {
    return new Swiper('.processlider-swiper', {
        spaceBetween: 30,
        navigation: navigation('processlider'),
        breakpoints: {
            993: {
                slidesPerView: 3,
            },
            768: {
                slidesPerView: 2,
            },
            0: {
                slidesPerView: 1,
            },
        },
        autoplay: {
            delay: 5000,
        },
    });
}

const teamSwiper = () => {
    $('.team-swiper').each(function() {
        const swiper = '.' + $(this).attr('class').toString().trim().split(' ').join('.');
        const navigation = '.' + $(this).next().attr('class').toString().trim().split(' ').join('.');
        new Swiper(swiper, {
            spaceBetween: 30,
            navigation: {
                nextEl: navigation + ' .swiper-controls-next',
                prevEl: navigation + ' .swiper-controls-prev',
            },
            breakpoints: {
                993: {
                    slidesPerView: 3,
                },
                768: {
                    slidesPerView: 2,
                },
                0: {
                    slidesPerView: 1,
                },
            },
            autoplay: {
                delay: 5000,
            },
        });
    });
}

const contentslider = () => {
    return new Swiper('.content-swiper', {
        spaceBetween: 30,
        navigation: navigation('contentswiper'),
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
            0: {
                slidesPerView: 1,
            },
        },
    });
}

const vacaturesSwiper = () => {
    return new Swiper('.vacatures-swiper', {
        spaceBetween: 30,
        navigation: navigation('vacatures-swiper'),
        breakpoints: {
            992: {
                slidesPerView: 3,
            },
            767: {
                slidesPerView: 2,
            },
            0: {
                slidesPerView: 1.1,
            },
        },
        autoplay: {
            delay: 5000,
        },
    });
}
const dienstenSwiper = () => {
    return new Swiper('.diensten-swiper', {
        spaceBetween: 30,
        navigation: navigation('diensten-swiper'),
        breakpoints: {
            767: {
                slidesPerView: 2,
            },
            0: {
                slidesPerView: 1.05,
                spaceBetween: 15,
            },
        },
        autoplay: {
            delay: 8000,
        },
    });
}

const reviewsSwiper = () => {
    return new Swiper('.reviews-swiper', {
        spaceBetween: 30,
        navigation: navigation('reviews-swiper'),
        autoHeight: true,
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
            0: {
                slidesPerView: 1,
            },
        },
        autoplay: {
            delay: 5000,
        },
    });
}

const fullAanbod = el => {
    return new Swiper('.' + el + '-swiper', {
        spaceBetween: 0,
        loop: true,
        navigation: navigation(el),
        slidesPerView: 1,
        keyboard: true,
    });
}

const relatedSwiper = () => {
    return new Swiper('.recent-swiper', {
        spaceBetween: 30,
        navigation: navigation('recent'),
        breakpoints: {
            992: {
                slidesPerView: 3,
            },
            767: {
                slidesPerView: 2,
            },
            0: {
                slidesPerView: 1.05,
            },
        },
        autoplay: {
            delay: 9000,
        },
    })
}
